export function $t(text, params = null) {

  if (!window.siteData.i18n) {
    console.log(text)
    return text;
  }

  let translatedText = window.siteData.i18n[text];

  if (!translatedText) {
    return text;
  }

  // if(params) {
  //   Object.keys(params).forEach((key) => {
  //     const value = params[key];

  //     console.log(key, value);

  //     translatedText = translatedText.replace(`/\[\[\s*${key}\s*\]\]/`, value);
  //   });
  // }

  return translatedText;
}
